import React from "react"
import PropTypes from "prop-types"
import { GatsbyImage } from "gatsby-plugin-image"
import { useSetting } from "../data/useSetting"
import { useContactImage } from "../data/useContactImage"
import { Button } from "./Button"
import Link from "./Link"
import logo from "../images/mentalhugs_logo.svg"
import CtaButton from "./CtaButton"

export const BackgroundColorCTA = ({ cta }) => {
  const { contentfulSetting: setting } = useSetting()
  return (
    <div className="bg-red-50 rounded-tr-3xl rounded-bl-3xl px-6 sm:px-12 pt-8 sm:pt-12">
      {/* Content */}
      <p className="text-lg sm:text-2xl text-center tracking-wide font-bold text-gray-700">
        {cta?.excerpt ||
          " 歡迎您與我們的心理師們一同擁抱心理、擁抱自己，擁有更棒的生命品質！"}
      </p>
      {/* Button */}
      <div className="text-center py-6 sm:py-8">
        <Link as="a" to={cta?.link || setting.lineLink}>
          <div className="sm:hidden">
            <Button
              className={`convert ${
                cta?.gtmClickClasses ? cta?.gtmClickClasses : ""
              }`}
              size="md"
            >
              {cta?.title || "聯繫擁抱"}
            </Button>
          </div>
          <div className="hidden sm:block">
            <Button
              className={`convert ${
                cta?.gtmClickClasses ? cta?.gtmClickClasses : ""
              }`}
              size="lg"
            >
              {cta?.title || "聯繫擁抱"}
            </Button>
          </div>
        </Link>
      </div>
    </div>
  )
}

export const BackgroundImageCTA = ({
  className = "",
  isIconIncluded = false,
}) => {
  const { contentfulSetting: setting } = useSetting()
  const { contactImage } = useContactImage()

  return (
    <div className={`relative w-full ${className}`}>
      <div className="absolute inset-0 w-full">
        <GatsbyImage
          image={contactImage.contactImage.gatsbyImageData}
          alt="hug"
          className="w-full h-full"
        />
      </div>
      <div
        className={`relative z-10 w-full h-full flex-col justify-center items-center px-6 sm:px-8 ${
          isIconIncluded
            ? "py-12 lg:py-24"
            : "pt-36 pb-12 sm:pt-44 sm:pb-20 lg:pt-80 lg:pb-36"
        }`}
      >
        {isIconIncluded && (
          <div className="flex justify-center mb-8">
            <img
              src={logo}
              width={112}
              height={112}
              alt="mental-hug's logo"
              style={{ borderRadius: "50%" }}
            />
          </div>
        )}
        <p className="text-shadow text-3xl sm:text-5xl leading-tight text-center tracking-widest font-bold text-white">
          擁抱心理，擁抱愛與自己
        </p>
        <p className="mt-1 sm:mt-2 text-shadow text-sm sm:text-3xl leading-tight text-center tracking-widest text-white">
          全預約制，請透過LINE@或撥打預約專線02-7748-0995
        </p>
        {/* CTA */}
        <div className="flex flex-row justify-center gap-5 sm:gap-6 mt-8 sm:mt-16 text-center">
          <CtaButton
            as={`a`}
            to={setting.lineLink}
            title={`立即諮詢`}
            size={`base`}
            smSize={`lg`}
          />
          <CtaButton
            as={`a`}
            to={setting.reserveLink}
            title={`桃園門診預約`}
            size={`base`}
            smSize={`lg`}
          />
        </div>
      </div>
    </div>
  )
}

BackgroundColorCTA.propTypes = {
  cta: PropTypes.object,
}

BackgroundImageCTA.propTypes = {
  className: PropTypes.string,
  isIconIncluded: PropTypes.bool,
}
